import { UrlConstants } from "../url.constants";
export class ApiRecipientConstants {
    static URL = UrlConstants.API_V2 + "Recipient";
    static FUNCTION_DELETE_MULTIPLE_RECIPIENTS = "DeleteMultipleRecipients";
    static FUNCTION_DELETE_GROUPS = "DeleteGroups";
    static FUNCTION_ADD_GROUPS = "AddGroups";
    static FUNCTION_GET_RECIPIENT_FROM_TABLE_AND_FIELD = "GetRecipientFromTableAndField";
    static FUNCTION_GET_RECIPIENTS_BY_GROUP = "GetRecipientsByGroup";
    static FUNCTION_GET_PORTAL_RECIPIENTS_BY_GROUP = "GetPortalRecipientsByGroup";
    static FUNCTION_GET_PORTAL_RECIPIENT = "GetPortalRecipients";
}
